import cn from 'clsx'
import styles from './headerblock.css'

type HeaderBlockProps = {
  value: {
    heading?: string
    text?: string
    background?: string
    color?: string
  }
}

const HeaderBlock = ({ value: { heading, text, background: backgroundColor, color = 'black' } }: HeaderBlockProps): JSX.Element => {
  return (
    <div style={{ backgroundColor }}>
      <div className={cn(styles.wrapper, backgroundColor && styles.withBg)}>
        {heading && <h2 style={{ color }}>{heading}</h2>}
        {text && <p style={{ color }}>{text}</p>}
      </div>
    </div>
  )
}

export default HeaderBlock
